import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
          setError("Missing session_id");
          return;
        }
        const sessionId = decodeURIComponent(m[1]);
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (cancelled) return;
        // Clean hash and navigate to admin dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "התחברות נכשלה";
        toast.error(msg);
        setError(msg);
        setTimeout(() => navigate("/admin/login", { replace: true }), 1500);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-4 border-brand-amber border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-stone-600">{error || "מתחבר..."}</p>
      </div>
    </div>
  );
}
